export { FirstLetterPipe } from './first-letter.pipe';
